import { SET_CAM_GROUP_POSITION, SET_CHANNEL_POSITION, SET_INITIAL_ACTIVE_CHANNEL } from '../constants';

export function setCamGroupNavPosition(index) {
  return {
    type: SET_CAM_GROUP_POSITION,
    payload: {
      data: index
    }
  };
}

export function setChannelNavPosition(index) {
  return {
    type: SET_CHANNEL_POSITION,
    payload: {
      data: index
    }
  };
}

export function setInitialActiveChannel(id) {
  return {
    type: SET_INITIAL_ACTIVE_CHANNEL,
    payload: {
      data: id,
    },
  };
}
